/*
 * Copyright (c) 2024 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain
 * proprietary information of OCLC, Inc. and shall not be disclosed in whole or in
 * any part to any third party or used by any person for any purpose, without written
 * consent of OCLC, Inc.  Duplication of any portion of these  materials shall include this notice.
 *
 */

import {
  resolveLocale,
  resolveLanguage,
  resolveMessages,
} from '../config/i18n';

const locale = resolveLocale();
console.log(`Resolving user locale to ${locale}`);
const language = resolveLanguage(locale);
console.log('Resolved language', language, ' for locale ', locale);

const messages = resolveMessages(locale, (locale) =>
  require(`./messages/messages_${locale}.json`),
);

export { locale, messages };
